import { fillString } from '@local_modules/generic/string-template'

/**
 *
 * @param {*} htmlContent
 * @param {*} appAccount
 * @returns
 */
export function applyAccountData (htmlContent, browserAppAccount) {
  if (!htmlContent) return null

  if (!browserAppAccount?.data?.appAccount) return htmlContent

  const appAccount = browserAppAccount?.data?.appAccount
  if (!appAccount) return htmlContent

  let html = htmlContent

  if (appAccount?.isPublic) {
    html = html.replaceAll(':publicIcon', '<i class="fa-solid fa-globe right-margin "></i>')
  } else {
    html = html.replaceAll(':publicIcon', ' ')
  }

  return fillString(html, {
    accountName: appAccount.name,
    accountId: appAccount.mongo_id, // TODO: Deprecate
    appAccountId: appAccount.id
  })
}
